import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Box, TextField } from '@mui/material';

interface MessageSectionProps {
  control: Control<Gift.Crud>;
  dictionary: any;
}

const MessageSection: React.FC<MessageSectionProps> = ({ control, dictionary }) => {
  return (
    <Box>
      <Controller
        name="message"
        control={control}
        rules={{ required: dictionary.forms.validations.required }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            label="Personal Message"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            multiline
            rows={4}
            fullWidth
            slotProps={{
              input: {
                sx: {
                  'fieldset': {
                    borderRadius: '10px',
                  },
                },
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default MessageSection;
